<template>
  <div>
    <el-form-item label="地址">
      <el-input v-model="data.value" placeholder="如：http://www.wiseloong.com?processCode=${processCode}" type="textarea"></el-input>
    </el-form-item>
    <el-form-item label="链接方式" >
      <el-select v-model="data.targetType"  placeholder="请选择链接方式">
        <el-option label="新窗口" value="_blank"></el-option>
        <el-option label="弹出窗口" value="dialog"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否全屏" v-if="data.targetType === 'dialog'">
      <el-select v-model="data.fullscreen"  placeholder="请选择是否全屏">
        <el-option label="否" value="false"></el-option>
        <el-option label="是" value="true"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="弹框宽度" v-if="data.targetType === 'dialog' && data.fullscreen !== 'true'">
      <el-input v-model="data.width" placeholder="请输入宽度"></el-input>
    </el-form-item>
    <el-form-item label="弹框高度" v-if="data.targetType === 'dialog' && data.fullscreen !== 'true'">
      <el-input v-model="data.height" placeholder="请输入高度"></el-input>
    </el-form-item>
    <el-form-item label="确认按钮名称" v-if="data.targetType === 'dialog'">
      <el-input v-model="data.confirmName" placeholder="请输入确认按钮名称"></el-input>
    </el-form-item>
    <el-form-item label="取消按钮名称" v-if="data.targetType === 'dialog'">
      <el-input v-model="data.cancelName" placeholder="请输入取消按钮名称"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ConfigHyperLink',
  props: ['data'],
  data() {
    return {
      validator: {
        type: null,
        pattern: null,
        length: null
      }
    }
  },
  mounted() {
  },
  methods: {
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    }
  },
  watch: {

  }
}
</script>
